import { useQuery } from '@tanstack/react-query'
export function useActionLogs<TData>(config: {
  queryKey: readonly unknown[]
  fetchFn: () => Promise<TData>
  enabled?: boolean
}) {
  return useQuery({
    queryKey: config.queryKey,
    queryFn: () => config.fetchFn(),
    enabled: config.enabled ?? true,
  })
}
